import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mmb-web-app-add-social-link',
  templateUrl: './add-social-link.component.html',
  styleUrls: ['./add-social-link.component.scss']
})
export class AddSocialLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
